import { Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { FuelLevel } from '../models/fuel-level.model';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FuelLevelStateService {
  public isLoading: Signal<boolean> = signal(true);
  public fuelLevels: Signal<FuelLevel[]> = signal([]);

  public fuelLevelSelectedSubject$: Subject<void> = new Subject<void>();
  public fuelLevelSelected$: Observable<void> = this.fuelLevelSelectedSubject$.asObservable();

  public lowFuelLevelSelectedSubject$: Subject<FuelLevel> = new Subject<FuelLevel>();
  public lowFuelLevelSelected$: Observable<FuelLevel> = this.lowFuelLevelSelectedSubject$.asObservable();

  constructor() { }

  setFuelLevels(fuelLevels: FuelLevel[]): void {
    (this.fuelLevels as WritableSignal<FuelLevel[]>).set(fuelLevels);
    this.fuelLevelSelectedSubject$.next();
  }

  setIsLoading(isLoading: boolean): void {
    (this.isLoading as WritableSignal<boolean>).set(isLoading);
  }
}